module.exports = {
	"dk": {
		"startpage": {
			"manualList": "b675475b-5709-4f3b-a80a-09c3ff0d0385",
			"templateId": "dk.startpage"
		},
		"fodbold": {
			"manualList": "a415f614-ef1e-426e-89a7-9da882ba977c",
			"templateId": "dk.footballPage"
		},
		"emfodbold": {
			"manualList": "61861c62-fd42-4f45-8407-cdfa0ad80fd3",
			"templateId": "dk.emfootballPage"
		},
		"ishockey": {
			"manualList": "37b2b7b4-af9e-4c3c-8b5a-7864b4653869",
			"templateId": "dk.iceHockeyPage"
		},
		"motorsport": {
			"manualList": "adc00f52-e453-4215-9d19-1aa7868ac065",
			"templateId": "dk.motorPage"
		},
		"golf": {
			"manualList": "8424e0d2-4ac8-4e4b-a5b9-29d244bb2fb4",
			"templateId": "dk.golfPage"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config/newsFeed.json
// module id = 1045
// module chunks = 1 2